const { FRONT_CONFIG } = window;
const mobileMedia = window.matchMedia(
  `(max-width: ${FRONT_CONFIG.responsive.bp_1025}px)`
);
const desktopBreakpoint = FRONT_CONFIG.responsive.bp_1025;
const FOOTER_INLINE_CLASS = 'footer--newsletter-inline';
const minWidthNewsletterForm = '650';

const isMatchedBreakpoint = require('../common/utils/isMatchedBreakpoint');
const { forEachElement } = require('../common/utils/dom');

const toggleExpandedFooterLink = (target) => {
  const footer = document.querySelector('.footer');
  if (target.classList.contains('expanded')) {
    target.classList.remove('expanded');
    $('body').trigger('transition-m2', [
      target.nextElementSibling,
      false,
      footer,
    ]);
  } else {
    const expanded = document.querySelector('.footer .expanded');
    if (expanded !== null) expanded.classList.remove('expanded');
    target.classList.add('expanded');
    $('body').trigger('transition-m2', [
      target.nextElementSibling,
      true,
      footer,
    ]);
  }
};

const toggleNewsletterInline = () => {
  const footerContainer = document.querySelector('.footer');
  if (!footerContainer) return;

  const isDesktop = isMatchedBreakpoint.matches(
    `bp_${desktopBreakpoint}`,
    'min-width'
  );
  if (!isDesktop) {
    footerContainer.classList.remove(FOOTER_INLINE_CLASS);
    return;
  }

  // Use as anchor the last menu item before the newsletter element
  const previousTooglerNewsletter = document.querySelector(
    '.footer .navlinks__toggler-newsletter'
  )?.previousElementSibling;
  if (!previousTooglerNewsletter) return;

  const { left, width } = previousTooglerNewsletter.getBoundingClientRect();

  // Calculate the space that would be available from the anchor
  const spaceAvailability = footerContainer.offsetWidth - (left + width);

  // Check if there is enough space for the form to be displayed
  if (spaceAvailability > minWidthNewsletterForm) {
    footerContainer.classList.add(FOOTER_INLINE_CLASS);
  } else {
    footerContainer.classList.remove(FOOTER_INLINE_CLASS);
  }
};

const showNewsletterModal = () => {
  const footerContainer = document.querySelector('.footer');
  if (!footerContainer) return;
  footerContainer.classList.toggle('footer--newsletter-show');

  if (!footerContainer.classList.contains(FOOTER_INLINE_CLASS)) {
    const newsletterModalContainer = document.querySelector(
      '.footer .newsletter-modal-container'
    );
    const scrollAdjust =
      window.innerHeight / 2 - $(newsletterModalContainer).height() / 2;
    $('html, body').animate(
      {
        scrollTop: $(newsletterModalContainer).offset().top - scrollAdjust,
      },
      50
    );
  }
};

const initNewsletterModal = () => {
  toggleNewsletterInline();
  // eslint-disable-next-line listeners/no-missing-remove-event-listener
  window.addEventListener('resize', toggleNewsletterInline, { passive: true });
  forEachElement(
    document.querySelectorAll(
      '.footer .navlinks__toggler-newsletter, .footer .newsletter-modal-container .btn-close'
    ),
    (item) => {
      item.addEventListener('click', showNewsletterModal);
    }
  );
};

/**
 * Listen to the footer country selector click to open the country selector modal
 */
function footerCountrySelectorListener() {
  const footerCountrySelectorToggler = document.querySelector(
    '.footer-country-selector-toggler'
  );
  if (!footerCountrySelectorToggler) {
    return;
  }

  const {
    methods: { show },
  } = require('./countrySelectorModal/countrySelectorModal');
  // eslint-disable-next-line listeners/no-missing-remove-event-listener
  footerCountrySelectorToggler.addEventListener('click', show);
}

module.exports = () => {
  if (mobileMedia.matches) {
    forEachElement(
      document.querySelectorAll(
        '.footer__parent-link :not(.navlinks__toggler-newsletter)'
      ),
      (item) => {
        // eslint-disable-next-line listeners/no-missing-remove-event-listener, listeners/no-inline-function-event-listener
        item.addEventListener('click', (e) => {
          toggleExpandedFooterLink(e.target);
        });
      }
    );
  }
  initNewsletterModal();
  footerCountrySelectorListener();
};
